import React from 'react';
import { useTranslation } from 'react-i18next';
import LightbulbIcon from '@/comp/common/icons/LightbulbIcon';
import styled from 'styled-components';
import { GlobalToken } from 'antd';

const EmptyStateContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme: { token } }) => token.paddingXL * 2}px ${({ theme: { token } }) => token.padding}px;
  text-align: center;
  grid-column: 1 / -1;
  min-height: 80vh;
  position: relative;
  width: 100%;
  gap: ${({ theme: { token } }) => token.marginLG}px;
`;

const EmptyStateBackground = styled.div<{ theme: { token: GlobalToken } }>`
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 8px;
  overflow: hidden;
  z-index: 0;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    max-width: 600px;
    max-height: 500px;
    background-image: radial-gradient(circle, rgba(255, 255, 255, 0.4) 1px, transparent 1px);
    background-size: 22px 22px;
    background-position: center center;
    opacity: 0.6;
    pointer-events: none;
    mask-image: radial-gradient(
      ellipse 70% 60% at 50% 50%,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0.9) 50%,
      rgba(0, 0, 0, 0.6) 70%,
      rgba(0, 0, 0, 0.3) 85%,
      rgba(0, 0, 0, 0) 100%
    );
    -webkit-mask-image: radial-gradient(
      ellipse 70% 60% at 50% 50%,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0.9) 50%,
      rgba(0, 0, 0, 0.6) 70%,
      rgba(0, 0, 0, 0.3) 85%,
      rgba(0, 0, 0, 0) 100%
    );
  }
`;

const EmptyStateContent = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme: { token } }) => token.marginMD}px;
  position: relative;
  z-index: 1;
  max-width: 800px;
  width: 100%;
  padding: ${({ theme: { token } }) => token.paddingXL * 2}px;
`;

const EmptyStateIllustration = styled.div<{ theme: { token: GlobalToken } }>`
  width: 182px;
  height: 128px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ theme: { token } }) => token.marginMD}px;
  position: relative;

  svg {
    width: 100%;
    height: 100%;
  }
`;

const EmptyStateTitle = styled.h3<{ theme: { token: GlobalToken } }>`
  font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  color: ${({ theme: { token } }) => token.colorText};
  margin: 0;
  text-align: center;
  white-space: nowrap;

  @media (max-width: 768px) {
    white-space: normal;
  }
`;

// const EmptyStateDescription = styled.p<{ theme: { token: GlobalToken } }>`
//   font-size: ${({ theme: { token } }) => token.fontSize}px;
//   font-weight: 400;
//   color: ${({ theme: { token } }) => token.colorTextTertiary};
//   margin: 0;
//   text-align: center;
//   max-width: 600px;
//   white-space: pre-wrap;
// `;

interface EmptyInsightsStateProps {
  activeTab: string;
}

const EmptyInsightsState: React.FC<EmptyInsightsStateProps> = ({ activeTab }) => {
  const { t } = useTranslation();

  const getTitle = () => {
    if (activeTab === 'insight') {
      return t('NoDraftInsightsTitle');
    } else if (activeTab === 'published') {
      return t('NoOpenedInsightsTitle');
    } else {
      return t('NoArchivedInsightsTitle');
    }
  };

  return (
    <EmptyStateContainer>
      <EmptyStateBackground />
      <EmptyStateContent>
        <EmptyStateIllustration>
          <LightbulbIcon width={182} height={128} />
        </EmptyStateIllustration>
        <EmptyStateTitle>
          {getTitle()}
          <br />
          {/* {t('LetsMakeFirstOneTogether')} */}
        </EmptyStateTitle>
        {/* {activeTab === 'insight' && (
          <>
            <EmptyStateDescription>{t('EmptyStateDescription')}</EmptyStateDescription>
            <Button
              type="primary"
              onClick={() => {
                // TODO: Implement create new insight functionality
                console.log('Create New Insight clicked from empty state');
              }}
              style={{ marginTop: token.marginMD }}
            >
              {t('CreateNewInsight')}
            </Button>
          </>
        )} */}
      </EmptyStateContent>
    </EmptyStateContainer>
  );
};

export default EmptyInsightsState;
